/**
 * Converts a given string to a valid slug
 * @param string User input
 */
export function stringToSlug(string: string, maxLength?: number): string {
  return (
    string
      // replace non-alphanumeric characters with `_`
      .replace(/\W/g, '_')
      // remove leading underscores or digits
      .replace(/^[_|\d]+/, '')
      // remove trailing underscores
      .replace(/[_]+$/, '')
      // force lowercase
      .toLowerCase()
      // slice to max length (if provided)
      .slice(0, maxLength)
  )
}
